export class UserBasicInfo {
    id: number
    name: string
    email: string
}
